<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

import { reportOrderIssue } from '@/graph/mutations/issues'

import orderReportReasons from '@/assets/order-report-reasons'

export default {
  name: 'OrderIssueView',
  mixins: [validationMixin],
  data: () => ({
    rules,
    items: orderReportReasons,

    form: {
      details: '',
      reason: null
    },
    submitting: false
  }),
  methods: {
    // Go back
    goBack() {
      if (this.form.reason) return (this.form.reason = null)
      this.$router.go(-1)
    },

    submit() {
      if (this.submitting || this.$v.$invalid) return
      this.submitting = true

      const { id } = this.$route.params
      const data = this.form

      reportOrderIssue(id, data)
        .then(() => {
          this.$router
            .replace({ name: 'MyOrdersView' })
            .then(() => this.$toast('Sent. We’ll be in touch soon.'))
        })
        .finally(() => (this.submitting = false))
    }
  },
  validations: {
    form: {
      reason: { required },
      details: { required }
    }
  }
}
</script>

<template>
  <div>
    <!-- Toolbar -->
    <v-app-bar color="white" flat app>
      <v-btn icon @click="goBack">
        <v-icon color="black" size="18">$vuetify.icons.arrowBack</v-icon>
      </v-btn>
    </v-app-bar>

    <transition name="slide-up" appear>
      <!-- Order issue view page -->
      <div class="view-grid">
        <div class="content-top px-3">
          <div class="display-1 font-weight-bold mb-3 px-2">
            Order issue
          </div>

          <div>
            <p class="body-2 mt-1 px-2">
              Choose the issue you had, and we'll get back to you as soon as we
              can.
            </p>

            <v-layout v-if="!form.reason" row wrap>
              <v-list class="flex-grow-1">
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  class="px-5"
                  @click="form.reason = item.reason"
                >
                  <v-list-item-icon class="mr-3 ml-2">
                    <v-icon color="secondary" size="17" v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2">
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-layout>

            <transition name="fade" appear>
              <form v-if="form.reason" class="px-2" @submit.prevent="submit()">
                <v-textarea
                  v-model="form.details"
                  :rules="[rules.required]"
                  name="issue-details"
                  label="Tell us all about it..."
                  rows="1"
                  auto-grow
                />
                <v-btn
                  :loading="submitting"
                  :disabled="$v.$invalid"
                  type="submit"
                  depressed
                  rounded
                  color="primary"
                  class="mt-2 px-8 body-2"
                >
                  Submit
                </v-btn>
              </form>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="sass" scoped>
.content-top
  margin-top: 56px

.v-list-item
  font-size: 15px
  min-height: 30px
  padding: 0
</style>
